import React, { useState } from "react";
import { Tab, Nav, Form, TabPane, Button } from "react-bootstrap";
import Pagination from "react-bootstrap/Pagination";
import { Link, useNavigate } from "react-router-dom";
import {
  decryptString,
  getName,
  getTabStatus,
  goToClientDashboard,
  mobileNumber,
  noDataFound,
  splitDate,
} from "../../CommonMethhods/CommonMethods";
import { Constants } from "../../CommonMethhods/Constants";
import Loader from "../../Components/Common/Loader";

function OnboardingPendingCard(props) {
   const cosmosRid = localStorage.getItem("cosmosRid");
  let navigate = useNavigate();
  let serverError = props.serverError;
  const { checkPending, linecard } = props;

  const [showSidebar, setShowSidebar] = useState(false);
  const { selectedClient, setSelectedClient, handleRedirect } = props;

  const stages = [
    { key: "Mobile", label: "Mobile Verified" },
    { key: "Email", label: "Email Verified" },
    { key: "Document", label: "Document" },
    { key: "PersonalDetails", label: "Personal Details" },
    { key: "BankDetails", label: "Bank Verification" },
    { key: "SignUpload", label: "Signature" },
    { key: "Selfie", label: "Selfie" },
    { key: "Esign", label: "E-sign Completed" },
  ];

  const handleCardClick = (client) => {
    if (linecard === "block-active col-division-5") {
      setSelectedClient(client);
      setShowSidebar(true);
      // Prevent body scroll
      document.body.style.overflow = "hidden";
    }
  };

  const handleCloseSidebar = () => {
    setShowSidebar(false);
    // Restore body scroll
    document.body.style.overflow = "unset";
    setTimeout(() => setSelectedClient(null), 300);
  };

  const getCompletedWidth = (client) => {
    const lastCompletedIndex = stages.findLastIndex(
      (s) => client.retailStages?.[s.key]
    );
    let completedWidth = 0;
    if (lastCompletedIndex >= 0) {
      completedWidth = ((lastCompletedIndex + 1) / (stages.length - 1)) * 100;
      if (completedWidth > 100) completedWidth = 100;
    }
    return completedWidth;
  };
  const panVal = selectedClient?.pan
  ? decryptString(selectedClient.pan)
  : "";
  const mobVal = selectedClient?.mobile
  ? decryptString(selectedClient.mobile)
  : "";

  return (
    <>
      {/* Overlay */}
      {showSidebar && (
        <div className="sidebar-overlay" onClick={handleCloseSidebar}></div>
      )}

      {/* pending tab start */}
      <Tab.Pane eventKey="Pending" className="pendingClass">
        <div className="row">
          <div className="col-12">
            <div
              className="oboarding-block-wrapper card-box alert-table text-center"
              onScroll={(e) => props.handleScroll(e)}
            >
              {checkPending.length > 0 ? (
                <div
                  className={` ${
                    linecard === "block-active col-division-5"
                      ? "onboarding-card-wrapper"
                      : ""
                  }`}
                >
                  {checkPending.map((item, index) => {
                    const completedWidth = getCompletedWidth(item);
                    const decryptedPan = item?.pan ? decryptString(item?.pan) : "";
                    const decryptedMobile = item?.mobile ? decryptString(item?.mobile) : "";

                    console.log(item, "item8899");
                    

                    return (
                      <div
                        key={index}
                        className={`w-100 bottom-25 ${linecard}`}
                        onClick={() => handleCardClick(item)}
                        style={{
                          cursor:
                            linecard === "block-active col-division-5"
                              ? "pointer"
                              : "default",
                        }}
                      >
                        <div
                          className="card-box onboarding-card"
                          style={{
                            cursor:
                              linecard === "block-active col-division-5"
                                ? "pointer"
                                : "default",
                          }}
                        >
                          <div className="client-img-checkbox-wrapper">
                            <div className="client-img-wrapper">
                              <div className="profile-image">
                                {item?.clientname
                                  ? getName(item?.clientname)
                                  : "N.A"}
                              </div>
                            </div>
                          </div>
                          <div className="onboarding-card-content">
                            <div className="onboarding-card-top">
                              <div className="user-email-wrapper">
                                <p className="username">
                                  <span>{item.clientname}</span>
                                </p>
                                <p className="email">
                                  {item?.emailid ? item?.emailid : "N.A"}
                                </p>
                              </div>
                            </div>
                            <div className="clientname-info">
                              <ul className="call-web-wrapper justify-content-center">
                                <li className="created-time-wrapper">
                                  <span className="icon-calendar onboard-pending-icon"></span>
                                  <span className="onboard-sm-icon-label">
                                    <span>
                                      {item?.createddatetime
                                        ? splitDate(item?.createddatetime)
                                        : "N.A"}
                                    </span>
                                  </span>
                                </li>
                              </ul>

                              <div className="client-info-status">
                                <ul className="call-web-wrapper">
                                  <li>
                                    <span className="icon-phone-icon onboard-pending-icon"></span>
                                    <span className="onboard-sm-icon-label">
                                      <span>
                                        {decryptedMobile
                                          ? mobileNumber(decryptedMobile)
                                          : "N.A"}
                                        {/* {item.mobile ? item?.mobile : "N.A"} */}
                                      </span>
                                    </span>
                                  </li>
                                  <li>
                                    <span className="icon-android onboard-pending-icon"></span>
                                    <span className="onboard-sm-icon-label">
                                      <span>
                                        {decryptedPan
                                          ? mobileNumber(decryptedPan)
                                          : "N.A"}
                                      </span>
                                    </span>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                          {linecard !== "block-active col-division-5" && (
                            <>
                              <div className="progress-wrapper ">
                                <div className="progress-track">
                                  <div
                                    className="progress-completed"
                                    style={{ width: `${completedWidth}%` }}
                                  ></div>
                                </div>

                                <div className="progress-dots">
                                  {stages.map((stage, idx) => {
                                    const isCompleted =
                                      item.retailStages?.[stage.key];                                      

                                    return (
                                      <div
                                        key={idx}
                                        className="progress-dot-wrapper"
                                      >
                                        <div
                                          className={`progress-dot ${
                                            isCompleted
                                              ? "bg-success"
                                              : "bg-secondary"
                                          }`}
                                        ></div>
                                        <small className="dot-label">
                                          {stage.label}
                                        </small>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                              <Button
                                className={`no-focus ${
                                  item?.retailStages?.Esign
                                    ? "edit-btn-disabled"
                                    : ""
                                }`}
                                onClick={() => handleRedirect(item)}
                                variant="outline-primary"
                                style={{
                                  height: "30px",
                                  fontSize: "12px",
                                  width: "15%",
                                }}
                                disabled={item?.retailStages?.Esign || false}
                              >
                                Edit
                              </Button>
                            </>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                serverError && (
                  <h4 className="alert-title mb-0">
                    {noDataFound(serverError)}
                  </h4>
                )
              )}
              {props.scrollLoader && (
                <div className="loader-center">
                  <Loader />
                </div>
              )}
            </div>
          </div>
        </div>
      </Tab.Pane>

      {/* Client Details Sidebar */}
      <div
        className={`client-details-sidebar ${showSidebar ? "show" : ""}`}
        style={{
          cursor: "default",
          userSelect: "text",
        }}
      >
        <div className="sidebar-header">
          <h2 className="mb-0">
            <strong>Client Details</strong>
          </h2>
          <button
            type="button"
            className="close-sidebar-btn"
            onClick={handleCloseSidebar}
          >
            ×
          </button>
        </div>
        {console.log(selectedClient, "selectedClient")
        }

        {selectedClient && (
          //   const panVal = decryptString(selectedClient?.pan);
          // const mobVal = decryptString(selectedClient?.mobile);
  
          <div className="sidebar-content">
            <div className="sidebar-client-info">
              <div className="client-img-checkbox-wrapper d-flex align-items-center">
                <div className="client-img-wrapper">
                  <div className="profile-image">
                    {selectedClient?.clientname
                      ? getName(selectedClient?.clientname)
                      : "N.A"}
                  </div>
                </div>
                <Button
                  variant="outline-primary"
                  size="sm"
                  className={`ml-auto mr-2 no-focus ${
                    selectedClient?.retailStages?.Esign
                      ? "edit-btn-disabled"
                      : ""
                  }`}
                  onClick={() => handleRedirect(selectedClient)}
                  style={{
                    width: "65px",
                    fontSize: "13px",
                    height: "30px",
                  }}
                  disabled={selectedClient?.retailStages?.Esign || false}
                >
                  Edit
                </Button>
              </div>

              <div className="d-flex justify-content-between align-items-start mb-3">
                <div>
                  <h6 className="client-name mb-1 text-primary">
                    {selectedClient.clientname}
                  </h6>
                  <p className="client-email mb-2">
                    {selectedClient?.emailid || "N.A"}
                  </p>

                  <div
                    className="d-flex justify-content-start mb-5"
                    style={{ fontSize: "11px", color: " #1a5da1ff" }}
                  >
                    <span
                      className="pr-1"
                      style={{ borderRight: "1px solid #1a5da1" }}
                    >
                      {selectedClient.createddatetime
                        ? splitDate(selectedClient.createddatetime)
                        : "N.A"}
                    </span>
                    <span
                      className="pr-1 pl-1 "
                      style={{ borderRight: "1px solid #1a5da1" }}
                    >
                      {(cosmosRid === "56" || cosmosRid === "53" || cosmosRid === "63" || cosmosRid === "12") ?
                        mobVal || "N.A"
                        : mobileNumber(mobVal) || "N.A"}
                      {/* {selectedClient.mobile || "N.A"} */}
                    </span>
                    <span className="pl-1">
                      {/* {selectedClient.pan || "N.A"} */}
                      {mobileNumber(panVal) || "N.A"}
                      </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Vertical Progress Bar with Stages */}
            <div className="sidebar-stages-progress">
              <div className="vertical-progress-container">
                {/* Progress Line */}
                <div className="vertical-progress-track">
                  <div
                    className="vertical-progress-fill"
                    style={{ height: `${getCompletedWidth(selectedClient)}%` }}
                  ></div>
                </div>

                {/* Stages */}
                <div className="vertical-stages-list">
                  {stages.map((stage, idx) => {
                    const isCompleted =
                      selectedClient.retailStages?.[stage.key];
                    return (
                      <div key={idx} className="vertical-stage-item">
                        <div
                          className={`stage-dot ${
                            isCompleted ? "completed" : "pending"
                          }`}
                        >
                          {isCompleted && <span className="dot-check">✓</span>}
                        </div>
                        <span className="stage-text">{stage.label}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default OnboardingPendingCard;
